import type { SVGProps } from 'react'

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 91 93'
    style={{ fill: 'none' }}
    {...props}
  >
    <path
      d='M75.6764 23.7598L34.1843 65.5786L15.3242 46.57'
      strokeWidth='14'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

Check.toString = () => 'check'
